import { PropertySurchargeForm } from "@/features/pricing/property-surcharge-form";

export function PropertyTypeSurchargesScreen() {
  return (
    <div className="p-4 space-y-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Property Type Surcharges</h1>
        <p className="text-gray-600 mt-2">
          Configure destination property-type surcharges, globally or per
          carrier service.
        </p>
      </div>
      <PropertySurchargeForm />
    </div>
  );
}
